<template>
  <div>
    <div class="flex flex-wrap">
      <div class="flex-1 flex justify-center mx-5">
        <div class="produit-usage_main_cibles_recepteur"></div>
        <dynamic-text-listing
          class="mt-5"
          :list="item.cultivations"
        ></dynamic-text-listing>
      </div>
      <div class="flex-1 flex justify-center mx-5">
        <div class="produit-usage_main_cibles_cible"></div>
        <dynamic-text-listing
          :list="item.targets"
          class="mt-5"
        ></dynamic-text-listing>
      </div>
      <div
        v-if="!isProductMO && filteredTreatments && filteredTreatments.length"
        class="flex-1 flex justify-center mx-5"
      >
        <span class="mt-5 whitespace-nowrap">
          <span class="text-orange font-bold"> Traitement : </span>
          {{ treatmentsLabels }}
        </span>
      </div>
    </div>

    <terms-row-table
      class="my-2"
      :terms="item.termsofuses_set"
      :item="product"
    ></terms-row-table>

    <div
      v-if="!isProductMO && !isProductBiocide"
      class="border border-gris-bordure"
    >
      <div class="py-1 px-4 bg-gris-bordure text-white">ZNT</div>
      <div class="p-2">
        <div v-if="firstTerm.aquatic_znt">
          <span class="text-gris">ZNT aquatique : </span>
          {{ firstTerm.aquatic_znt }} m.
          {{ firstTerm.aquatic_znt_infos }}
        </div>

        <div
          v-if="
            firstTerm.zone_vegetalisee &&
            firstTerm.zone_vegetalisee !== 'Non notifié'
          "
        >
          <span class="text-gris">Zone végétalisée : </span>
          {{ firstTerm.zone_vegetalisee }}
        </div>

        <div v-if="firstTerm.earth_znt_cultivated">
          <span class="text-gris">ZNT terrestre zone cultivée : </span>
          {{ firstTerm.earth_znt_cultivated }}
        </div>

        <div v-if="firstTerm.earth_znt_not_cultivated">
          <span class="text-gris">ZNT terrestre zone non cultivée : </span>
          {{ firstTerm.earth_znt_not_cultivated }}
        </div>

        <div v-if="firstTerm.earth_znt_comment">
          <span class="text-gris">Commentaire ZNT terrestre : </span>
          {{ firstTerm.earth_znt_comment }}
        </div>

        <div>
          <span>
            <span class="text-gris">Distance de sécurité riverain : </span>
            <span v-if="firstTerm.distance_secu_riverain"> {{ firstTerm.distance_secu_riverain }} m. </span>
            <span v-if="firstTerm.distance_secu_riverain === '' || firstTerm.distance_secu_riverain === null ">
                En l'absence de distance de sécurité spécifique fixée par l'autorisation de mise sur le marché du produit, veuillez-vous référer à l'arrêté du 27 décembre 2019.
            </span> 
            

          </span>
         
          <span v-if="firstTerm.distance_secu_riverain_comment">
            {{ firstTerm.distance_secu_riverain_comment }}
          </span>

          <span
            v-if="
              firstTerm.materiel_attenuation_derive &&
              firstTerm.materiel_attenuation_derive !== 'Non défini'
            "
          >
            Matériel d'atténuation de la dérive :
            {{ firstTerm.materiel_attenuation_derive }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="isCommentVisible" class="my-2 border border-gris-bordure">
      <div class="py-1 px-4 bg-gris-bordure text-white">Commentaire</div>
      <div class="p-2">
        <div>{{ firstTerm.specification_usage }}</div>

        <span
          v-if="
            firstTerm.debut_periode_application ||
            firstTerm.fin_periode_application ||
            firstTerm.periode_application
          "
        >
          Période d’application :
          {{
            [finDebutPeriodeApplication, firstTerm.periode_application]
              .filter(Boolean)
              .join(' ; ')
          }}
        </span>

        <div v-for="(restriction, index) in item.restrictions" :key="index">
          {{ restriction.autorisation ? 'Autorisé' : 'Interdit' }}
          {{ restriction.type === 4 ? '' : 'sur' }} :
          {{ restriction.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TermsRowTable from '@/components/TermsRowTable'
import DynamicTextListing from '@/components/DynamicTextListing'
import moment from 'moment'

export default {
  name: 'UseAccordionItem',
  components: { DynamicTextListing, TermsRowTable },

  props: {
    item: Object,
    product: Object
  },

  computed: {
    firstTerm () {
      return this.item.termsofuses_set?.[0] || {}
    },
    filteredTreatments () {
      return this.item.treatments?.filter((treatment) => !!treatment[0]) || []
    },
    treatmentsLabels () {
      return (
        this.filteredTreatments
          ?.map((treatment) => treatment[1])
          ?.join(' - ') || ''
      )
    },
    isProductMO () {
      return this.product.type === 'Macro-organisme'
    },
    isProductBiocide () {
      return this.product.type === 'Biocide'
    },
    isCommentVisible () {
      const firstTerm = this.firstTerm
      const item = this.item
      return Boolean(
        firstTerm.specification_usage ||
          firstTerm.periode_application ||
          item.restrictions.length ||
          firstTerm.debut_periode_application ||
            firstTerm.fin_periode_application
      )
    },

    finDebutPeriodeApplication () {
      return [
        this.firstTerm.debut_periode_application
          ? `à partir du ${this.formatApplicationDate(
            this.firstTerm.debut_periode_application
          )}`
          : null,
        this.firstTerm.fin_periode_application
          ? `jusqu'au ${this.formatApplicationDate(
            this.firstTerm.fin_periode_application
          )}`
          : null
      ]
        .filter(Boolean)
        .join(' ')
    }
  },

  methods: {
    formatApplicationDate (date) {
      return moment(date, 'DD-MM').format('Do MMMM')
    }
  }
}
</script>
